import { COUNTRY_SCHEMA } from '@src/components/ui/react-hook-form/country-select-input/country-select-input';
import { z } from 'zod';

export const ADDRESS_VALIDATOR = z
    .object({
        FirstName: z.string({ required_error: 'First name is required' }).min(1, 'First name is required'),

        LastName: z.string({ required_error: 'Last name is required' }).min(1, 'Last name is required'),

        Line1: z.string({ required_error: 'Address is required' }).min(1, 'Address is required'),

        Country: COUNTRY_SCHEMA,

        State: z.string({ required_error: 'Province is required' }).min(1, 'Province is required'),

        City: z.string({ required_error: 'City is required' }).min(1, 'City is required'),

        PostalCode: z
            .string({ required_error: 'Postal code is required' })
            .min(1, 'Postal code is required')
            .regex(/^[Vv]\d[A-Za-z]\s?\d[A-Za-z]\d$/, 'Please enter a valid postal code')
    })
    .passthrough();

export const CHECKOUT_VALIDATOR = z
    .object({
        FirstName: z.string({ required_error: 'First name is required' }).min(1, 'First name is required'),

        LastName: z.string({ required_error: 'Last name is required' }).min(1, 'Last name is required'),

        PhoneNumber: z
            .string({
                required_error: 'Phone number is required.'
            })
            .min(1, { message: 'Phone number is required' })
            .regex(/^[2-9]\d{2}[2-9]\d{2}\d{4}$/, 'Please enter a valid phone number'),

        Email: z.string({ required_error: 'Email is required' }).min(1, 'Email is required'),

        BillingAddress: z
            .object(
                {
                    ID: z
                        .string({ required_error: 'Billing address is required' })
                        .min(1, 'Billing address is required')
                },
                {
                    required_error: 'Billing address is required',
                    invalid_type_error: 'Billing address is required'
                }
            )
            .passthrough()
    })
    .passthrough();
